import React, { useContext, useEffect, useState } from "react";
import { Button, Dropdown, DropdownButton, Form, Image, InputGroup } from "react-bootstrap";
import { Search, List, Cart, X } from "react-bootstrap-icons";

import { Link, useLocation, useNavigate } from "react-router-dom";

import "./Header.scss";
import logo from "../assets/Logo.png";
import Menu from "./Menu";
import { AuthContext } from "../services/AuthContext";
import { User } from "lucide-react";
import "./Dropdown.scss"
import { usePage } from "../services/PageContext";
import ProductoAgregado from "./productos/ProductoAgregado";
import { NotificationsBell } from "./NotificationsBell";

export default function Header (){
  const [ inputValue, setInputValue ] = useState('');
  const { logout, isAuthenticated, user, cantProdCart } = useContext(AuthContext);
  const { isMobileStyle } = usePage()
  const [ showLateralMenu, setShowLateralMenu ] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const current = location.pathname;

  const search = () => {
    setInputValue('')
    navigate('/buscar/'+inputValue);
  }
  const goProfile = () => {
    navigate('/perfil-usuario/anuncios')
  }
  const handleLogOut = () => {
    logout();
    navigate('/')
  }
  const goCart = () => {
    navigate('/carrito')
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      search();
    }
  };

  useEffect(() => {
    setShowLateralMenu(false)
  }, [current])

  return (
    <>
      <header>
        <div className="fijo">
          <div className={`topbar ${isMobileStyle ? 'mobile' : ''}`}>
            {isAuthenticated
              ? <span>Hola {user.name}! Recordá que hacemos envíos a todo el país y el mínimo de compra es $300.000,00 (+IVA)</span>
              : <>
                  <div>
                      <Link to={'/registro'} >VENTA EXCLUSIVA MAYORISTA</Link>
                      <span> (los precios son netos, no incluyen IVA)</span>
                  </div>
                  {!isMobileStyle ? <span>   -   </span> : null}
                  <span><b>ENVÍOS A TODO EL PAÍS</b></span>
                </>
            }
          </div>
          <div className="top">
            <Link>
              <Image src={logo} />
            </Link>
            <div className={`header-item ${isMobileStyle ? 'mobile' : ''}`}>
              {!isMobileStyle &&
                <div className="search-field">
                  <InputGroup>
                    <Form.Control
                      placeholder="Buscar productos, marcas y más..." 
                      value={inputValue}
                      onChange={(e) => {setInputValue(e.target.value)}}
                      onKeyDown={handleKeyDown}
                    />
                    <Button variant="outline-secondary" id="button-addon1" onClick={()=>{search()}}>
                      <Search />
                    </Button>
                  </InputGroup>
                </div>
              }
              <div className="right-bar">
                <div className="profile-data">
                  {!isMobileStyle 
                    ? !isAuthenticated
                      ? <Link to={`/login`}>Iniciar Sesión</Link>
                      : <>
                        <DropdownButton
                          title={
                                <span>
                                  <User />
                                  {user.name}{user.clientName ? user.clientName !== '' ? ` (${user.clientName})` : '' : ''}
                                </span>
                              }>
                            <Dropdown.Item onClick={()=>goProfile()}>Mi cuenta</Dropdown.Item>
                            <Dropdown.Item onClick={()=>handleLogOut()}>Cerrar Sesión</Dropdown.Item>
                          </DropdownButton>
                          
                        </>
                    : <>
                      {showLateralMenu
                      ? <Button variant="outline" onClick={()=>setShowLateralMenu(false)}>
                          <X />
                        </Button>
                      : <Button variant="outline" onClick={()=>setShowLateralMenu(true)}>
                          <List />
                        </Button>
                      }
                      </>
                  }
                  {isAuthenticated
                    ? <>
                        {/* <NotificationsBell usuarioId={user.id} />  TODO: ver que pasa con esto*/}
                        <Button variant="outline" onClick={()=>goCart()} className={isMobileStyle ? 'mobile' : ''}>
                          <Cart />
                          <div className="notifications">{cantProdCart}</div>
                        </Button>
                      </>
                    :null}
                </div>
              </div>
            </div>
          </div>
          {isMobileStyle &&
                <div className="search-field mobile">
                  <InputGroup>
                    <Form.Control
                      placeholder="Buscar productos, marcas y más..." 
                      value={inputValue}
                      onChange={(e) => {setInputValue(e.target.value)}}
                      onKeyDown={handleKeyDown}
                    />
                    <Button variant="outline-secondary" id="button-addon1" onClick={()=>{search()}}>
                      <Search />
                    </Button>
                  </InputGroup>
                </div>
              }
        </div>
        <div>
          {isMobileStyle
            ? showLateralMenu ? <Menu lateral={true} /> : null
            : <Menu />
          }
        </div>
      </header>
      <ProductoAgregado />
    </>
  )
}